import { SxProps, Theme } from "@mui/material";

export const pageWrapper: SxProps<Theme> = {
  width: "100%",
  minHeight: "100vh",
  background: "#040922",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  px: 2,
  py: 5,
};

export const backgroundGradient: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background:
    "radial-gradient(ellipse at 20% 10%, rgba(56,189,248,0.07) 0%, transparent 60%), radial-gradient(ellipse at 80% 80%, rgba(32,194,241,0.06) 0%, transparent 60%)",
  pointerEvents: "none",
};

export const logoWrapper: SxProps<Theme> = {
  position: "relative",
  mb: 4,
  display: "flex",
  justifyContent: "center",
};

export const spinner: SxProps<Theme> = {
  position: "relative",
  color: "#20C2F1",
};

export const formCard: SxProps<Theme> = {
  background: "#0b1120",
  border: "1px solid rgba(56,189,248,0.12)",
  borderRadius: "20px",
  boxShadow: "0 8px 48px rgba(0, 0, 0, 0.5)",
  p: { xs: 3, md: 5 },
  position: "relative",
  overflow: "hidden",
  width: "100%",
  maxWidth: 520,
};

export const headingText: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  mb: 1,
  color: "white",
};

export const subText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.7)",
  fontSize: "0.95rem",
  mb: 3,
};

export const alert: SxProps<Theme> = {
  mb: 3,
  fontFamily: "'Barlow', sans-serif",
  borderRadius: "12px",
};

export const darkInput: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    background: "rgba(255,255,255,0.05)",
    borderRadius: "12px",
    color: "white",
    fontFamily: "'Barlow', sans-serif",
    "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
    "&:hover fieldset": { borderColor: "rgba(32,194,241,0.4)" },
    "&.Mui-focused fieldset": { borderColor: "#20C2F1" },
  },
  "& .MuiInputLabel-root": {
    color: "rgba(255,255,255,0.5)",
    fontFamily: "'Barlow', sans-serif",
  },
  "& .MuiInputLabel-root.Mui-focused": { color: "#20C2F1" },
};

export const stripeElementWrapper: SxProps<Theme> = {
  background: "rgba(255,255,255,0.05)",
  borderRadius: "12px",
  border: "1px solid rgba(255,255,255,0.12)",
  px: 2,
  py: 1.75,
  transition: "border-color 0.2s ease",
  "&:hover": {
    borderColor: "rgba(32,194,241,0.4)",
  },
  "&:focus-within": {
    borderColor: "#20C2F1",
  },
};

export const stripeFieldLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.85rem",
  color: "rgba(255,255,255,0.5)",
  mb: 0.75,
};

export const stripeErrorText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.85rem",
  color: "#f87171",
  textAlign: "center",
};

export const checkbox: SxProps<Theme> = {
  color: "rgba(255,255,255,0.4)",
  "&.Mui-checked": { color: "#20C2F1" },
};

export const tosLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.7)",
  fontSize: "0.9rem",
};

export const tosLink: SxProps<Theme> = {
  color: "#20C2F1",
};

export const paymentDisclaimer: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.82rem",
  color: "rgba(255,255,255,0.45)",
  textAlign: "center",
};

export const lockIcon: SxProps<Theme> = {
  fontSize: 14,
  verticalAlign: "middle",
  mr: 0.5,
};

export const ctaButton: SxProps<Theme> = {
  background: "linear-gradient(90deg, #f97316, #fb923c)",
  borderRadius: "50px",
  py: 1.75,
  fontSize: "1rem",
  fontWeight: 700,
  fontFamily: "'Barlow', sans-serif",
  textTransform: "none",
  boxShadow: "0 4px 24px rgba(249,115,22,0.35)",
  "&:hover": { background: "linear-gradient(90deg, #ea6c0a, #f97316)" },
  "&.Mui-disabled": {
    background: "rgba(249,115,22,0.3)",
    color: "rgba(255,255,255,0.5)",
  },
};

export const footerLink: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.35)",
  textTransform: "none",
  fontSize: "0.85rem",
  px: 0,
  "&:hover": { color: "#20C2F1", background: "transparent" },
};
